import { registerWidget } from '../../../js/core/widget/widget-directory'
import { getProfileData } from '../account-data/account-data'
import registeredEvents from '../../../js/helpers/registered-events'
import { accountMenuEvents } from '../../../js/document/event-types'
const EventEmitter = require('eventemitter3')

const widgetApi = 'w-account-menu'

const classNames = {
  isOpen: 'is-open',
  isHidden: 'is-hidden',
  showAvatar: `${widgetApi}__button--show-avatar`
}

const attr = {
  track: 'data-track'
}

const widgetQueries = {
  trigger: `[data-${widgetApi}__trigger]`,
  dropdown: `[data-${widgetApi}__dropdown]`,
  loginItem: `[data-${widgetApi}__login-item]`,
  logoutItem: `[data-${widgetApi}__logout-item]`,
  logoutLink: `[data-${widgetApi}__logout-link]`,
  loginButton: `[data-${widgetApi}__login-btn]`,
  createAccountLink: `[data-${widgetApi}__create-account-link]`,
  bookingsOverviewLink: `[data-${widgetApi}__bookings-overview-link]`,
  favoritesButton: `[data-${widgetApi}__favorites-btn]`,
  sunwebCeLink: `[data-${widgetApi}__sunweb-ce-link]`,
  isSunwebCE: `data-${widgetApi}__is-sunweb-ce`

}

export default class AccountMenu {
  constructor (element) {
    if (!element) return
    this.element = element
    this._getHtmlElements()
    this._attachEvents()
    this._renderDropdown()
    this.events = new EventEmitter()
    registeredEvents.registerWidgetEvents(widgetApi, this.events, {
      ...this.element.hasAttribute(attr.track) && { track: this.element.attributes[attr.track].value }
    })
  }

  _getHtmlElements () {
    this.triggers = this.element.querySelectorAll(widgetQueries.trigger)
    this.dropdown = this.element.querySelector(widgetQueries.dropdown)
    this.loginItems = this.element.querySelectorAll(widgetQueries.loginItem)
    this.logoutItems = this.element.querySelectorAll(widgetQueries.logoutItem)
    this.logoutLink = this.element.querySelector(widgetQueries.logoutLink)
    this.loginButton = this.element.querySelector(widgetQueries.loginButton)
    this.createAccountLink = this.element.querySelector(widgetQueries.createAccountLink)
    this.bookingsOverviewLink = this.element.querySelector(widgetQueries.bookingsOverviewLink)
    this.favoritesButton = this.element.querySelector(widgetQueries.favoritesButton)
    this.sunwebCeLink = this.element.querySelector(widgetQueries.sunwebCeLink)
    this.isSunwebCE = this.element.hasAttribute(widgetQueries.isSunwebCE)
  }

  _attachEvents () {
    this.triggers.forEach(trigger => trigger.addEventListener('click', this._toggleDropdown.bind(this)))

    document.addEventListener('click', (event) => {
      const isClickInsideTrigger = Array.from(this.triggers).some(trigger => trigger.contains(event.target))
      if (!this.dropdown.contains(event.target) && !isClickInsideTrigger) {
        this._closeDropdown()
      }
    })

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this._closeDropdown()
      }
    })

    const eventMappings = {
      [widgetQueries.loginButton]: accountMenuEvents.MY_ACCOUNT_CLICKED,
      [widgetQueries.createAccountLink]: accountMenuEvents.CREATE_ACCOUNT_CLICKED,
      [widgetQueries.bookingsOverviewLink]: accountMenuEvents.MY_BOOKINGS_CLICKED,
      [widgetQueries.favoritesButton]: accountMenuEvents.FAVORITES_CLICKED
    }

    Object.entries(eventMappings).forEach(([selector, eventType]) => {
      const element = this.element.querySelector(selector)
      if (element) {
        element.addEventListener('click', () => this.events.emit(eventType))
      }
    })
  }

  _toggleDropdown () {
    if (this.element.classList.contains(classNames.isOpen)) {
      this._closeDropdown()
    } else {
      this.element.classList.add(classNames.isOpen)
      this.element.ariaExpanded = true
    }
  }

  _closeDropdown () {
    this.element.classList.remove(classNames.isOpen)
    this.element.ariaExpanded = false
  }

  _renderDropdown () {
    const profileData = getProfileData()

    if (!profileData) return

    if (profileData.isUserLoggedIn) {
      this._handleLoggedIn(profileData)
    } else {
      this._handleLoggedOut()
    }
  }

  _handleLoggedIn (profileData) {
    if (profileData.isSunwebCE && this.isSunwebCE) {
      this._setVisibility(this.loginItems, false)
      this._setVisibility(this.logoutItems, true)
      this.logoutLink.classList.remove(classNames.isHidden)
      this.sunwebCeLink.classList.add(classNames.isHidden)
      this.favoritesButton.classList.add(classNames.isHidden)
      this.bookingsOverviewLink.classList.add(classNames.isHidden)
      this._updateLogoutText()
    } else {
      this._setVisibility(this.loginItems, true)
      this._setVisibility(this.logoutItems, false)
    }
    this._renderAvatar(profileData)
  }

  _renderAvatar (profileData) {
    if (profileData.profileName) {
      const initial = profileData.profileName.charAt(0)
      this.triggers.forEach(trigger => {
        trigger.setAttribute('avatar-content', initial)
        trigger.classList.add(classNames.showAvatar)
      })
    }
  }

  _updateLogoutText () {
    const logoutButton = this.logoutLink.querySelector('button')
    if (!logoutButton) return

    const logoutSpan = logoutButton.querySelector('span')
    const contextText = logoutButton.getAttribute('data-text-context')
    if (logoutSpan && contextText) {
      logoutSpan.textContent = contextText
    }
  }

  _setVisibility (elements, show = true) {
    elements.forEach(el => {
      el.classList.toggle(classNames.isHidden, !show)
    })
  }

  _handleLoggedOut () {
    this._setVisibility(this.loginItems, false)
    this._setVisibility(this.logoutItems, true)
  }
}

registerWidget(AccountMenu, widgetApi)
